import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";

function Login() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      setError("");

      const response = await fetch("https://voice.vocalbox.in/api/Master/Login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "*/*"
        },
        body: JSON.stringify({
          userName: userName,
          password: password
        })
      });

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {

        // store session
        sessionStorage.setItem("UserName", data[0].UserName);
        sessionStorage.setItem("UserData", JSON.stringify(data[0]));

        navigate("/report");

      } else {
        setError("Invalid Username or Password");
      }

    } catch (err) {
      console.error(err);
      setError("Server error. Please try again.");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">

        <h2>Voice Panel Login</h2>
        <p className="login-subtitle">Login to continue</p>

        <input
          type="text"
          placeholder="Username"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={handleLogin}>
          Login
        </button>

        {error && <p className="error-text">{error}</p>}

      </div>
    </div>
  );
}

export default Login;